export const postCodes = {
  sanitizePostCode(postcode) {
    if (postcode === undefined || postcode === null) {
      return '';
    }
    return postcode.trim().replace(/ /g, '').toUpperCase();
  },
  isPostCodeValid(postcode) {
    if (postcode.length >= 5 && postcode.length <= 7) {
      var validPostCodeRegex = /^[a-z0-9]+$/i;
      if ((validPostCodeRegex.exec(postcode)) !== null) {
        return true;
      }
    }
  
    return false;
  }
}

export default postCodes